export const AI_NO_CREDITS_MESSAGE = "Te quedaste sin créditos de IA, recargá.";
export const AI_UNAVAILABLE_MESSAGE = "Servicio no disponible, reintentá.";
export const AI_GENERIC_ERROR_MESSAGE = "Ocurrió un error inesperado. Intentá de nuevo.";

/**
 * Traduce un error de las llamadas de IA a un mensaje para mostrar al usuario.
 *
 * @param {unknown} error Error capturado (típicamente de axios).
 * @param {{ notFoundMessage?: string }} [options] Mensaje específico para 404.
 * @returns {string} Mensaje listo para mostrar.
 */
export const getAiErrorMessage = (error, options = {}) => {
  const { notFoundMessage } = options;
  const responseStatus = error?.response?.status;

  if (responseStatus === 402) return AI_NO_CREDITS_MESSAGE;
  if (responseStatus === 502) return AI_UNAVAILABLE_MESSAGE;
  if (responseStatus === 404 && notFoundMessage) return notFoundMessage;

  return error?.response?.data?.detail || AI_GENERIC_ERROR_MESSAGE;
};
